import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LowStockViewModal from "./LowStockViewModal";

function LowStockView({ item, currency }) {
  const [lowStockDetails, setLowStockDetails] = useState();
  const handleClick = () => {
    setLowStockDetails(true);
  };
  return (
    <>
      <VisibilityIcon
        className="text-yellow-400 cursor-pointer"
        onClick={handleClick}
      />
      <LowStockViewModal
        currency={currency}
        lowStockDetails={lowStockDetails}
        setLowStockDetails={setLowStockDetails}
        item={item}
      />
    </>
  );
}

export default LowStockView;
